<p class="text-center" style="padding-bottom: 14px">
  <br>
  <img class="rounded mx-auto d-block img-responsive" src="assets/loading_spinner.gif" alt="{{ 'LOGOUT.LOADING' | transloco }}" />
  <br>
  {{ 'LOGOUT.LOADING' | transloco }}
</p>
